import edit from './edit';
import save from './save';
import accFloatPanelBlockMeta from './block.json';
import { accordionIcon as icon } from './icons';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = accFloatPanelBlockMeta;

registerBlockType(name, {
  ...settings,
  icon,
  edit,
  save,
});
